import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppContext } from '../../../saas/AppConfigWrapper';
import { getSeoForPath } from './seoRoutes';

/** Creates the <meta> when missing, then sets its content. */
const setMetaTag = (attribute, key, content) => {
  let tag = document.head.querySelector(`meta[${attribute}='${key}']`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attribute, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
};

/** Sets the canonical link, or removes it when the page has none. */
const setCanonicalLink = (href) => {
  let link = document.head.querySelector("link[rel='canonical']");
  if (!href) {
    link?.remove();
    return;
  }
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
  }
  link.setAttribute('href', href);
};

/**
 * Keeps <title>, meta description, canonical and their og: mirrors in sync
 * with the current route. Mount once inside the router; the copy lives in
 * `seoRoutes.js`.
 */
function PageSeo() {
  const { pathname } = useLocation();
  const { appConfig } = useAppContext();

  useEffect(() => {
    const { title, description, canonical } = getSeoForPath(
      pathname,
      appConfig?.companyName,
    );

    document.title = title;
    setMetaTag('name', 'description', description);
    setMetaTag('property', 'og:title', title);
    setMetaTag('property', 'og:description', description);
    setMetaTag('property', 'og:url', canonical || window.location.href);
    setCanonicalLink(canonical);
  }, [pathname, appConfig?.companyName]);

  return null;
}

export default PageSeo;
